// This is just an example,
// so you can safely delete all default props below

export default {
    title: 'Mine bestillinger',
    pdf: 'PDF',
    detail: 'Detaljer',
    order_time: 'Bestillingsdato',
    booking_number: 'Billettnr.',
    total: 'Billett sum',
    status: 'Status',
    status_open: 'Suksess',
    status_closed: 'Suksess',
    status_cancelled: "Avbestilt",
    cancel: "Avbestill",
    change: "Endring",
    cancelled_at: "Avbestilt",
    no_order: "Du har for øyeblikket ingen bestillinger knyttet til din konto."
}
